/* global FB */
window.fbAsyncInit = function () {
  FB.init({
    appId: window.fbAppId,
    autoLogAppEvents: true,
    xfbml: true,
    version: 'v16.0',
  });
};

var tag = document.createElement('script');
tag.src = 'https://connect.facebook.net/en_US/sdk.js';
tag.async = true;
tag.defer = true;
tag.crossOrigin = 'anonymous';
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.facebook-share-link').forEach((facebookShareLink) => {
    facebookShareLink.addEventListener('click', (event) => {
      event.preventDefault();
      const sharelink = event.target.dataset.href ? event.target.dataset.href : event.target.parentElement.dataset.href;
      if (FB) {
        FB.ui(
          {
            method: 'share',
            display: 'popup',
            href: sharelink,
          },
          function (response) {
            if (response && response.error_message) {
              console.error('Failed to open facebook share dialog. ' + response.error_message);
            }
          }
        );
      }
    });
  });
});
